import { readLegacySource, type LegacySource } from './source.ts';
import { mapLegacyState, type MapResult } from './map.ts';

export * from './crypto.ts';
export * from './source.ts';
export * from './map.ts';

export interface LegacyAnalysis extends MapResult { source: LegacySource; candidateIndex: number }

/**
 * Read-only analysis of a legacy VÉRO file: parse → (decrypt) → locate state → map in memory.
 * Nothing is written anywhere; the caller previews `report` and commits `dataset` through the
 * transactional restore pipeline (@vero/backup).
 */
export async function analyzeLegacy(text: string, opts: { password?: string; candidateIndex?: number; importedAt?: string } = {}): Promise<LegacyAnalysis> {
  const source = await readLegacySource(text, opts.password);
  const idx = Math.min(opts.candidateIndex ?? 0, source.candidates.length - 1);
  const cand = source.candidates[idx]!;
  const result = mapLegacyState(cand.state, {
    importedAt: opts.importedAt ?? new Date().toISOString(),
    externalNotes: source.externalNotes,
    extraRecords: source.extraRecords,
    sourceLabel: [source.wrapper.version, cand.origin !== 'file' ? cand.origin : ''].filter(Boolean).join(' · ') || undefined,
  });
  return { ...result, source, candidateIndex: idx };
}
